import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "../action-interfaces/Reports/HoldingReport";
class DpInterestReport {
    constructor(actions, usecases) {
        this.actions = actions;
        this.usecases = usecases;
    }
    getDpInterestCharges(req) {
        this.actions.dpInterestCharges.hideError("dpiCharges");
        this.actions.dpInterestCharges.loader("dpiCharges");
        this.usecases.dpiCharges.execute({
            onSuccess: (data) => {
                if (!!data && data.length < 1) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.DPC];
                    this.actions.dpInterestCharges.addMsg(emptyValidation.message, true, emptyValidation.icon, "dpiCharges");
                }
                else {
                    this.actions.dpInterestCharges.clear("dpiCharges");
                    this.actions.dpInterestCharges.getDpInterestCharges(data, "dpiCharges");
                }
                this.actions.dpInterestCharges.stopLoader("dpiCharges");
            },
            onError: (error) => {
                this.actions.dpInterestCharges.setError({
                    isOpen: true,
                    error,
                }, "dpiCharges");
                this.actions.dpInterestCharges.stopLoader("dpiCharges");
            },
        }, req);
    }
    getDpInterestDetails(req) {
        this.actions.dpInterestDetails.hideError("dpiDetails");
        this.actions.dpInterestDetails.loader("dpiDetails");
        this.usecases.dpiDetails.execute({
            onSuccess: (data) => {
                if (!!data && data.length < 1) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.DPC];
                    this.actions.dpInterestDetails.addMsg(emptyValidation.message, true, emptyValidation.icon, "dpiDetails");
                }
                else {
                    this.actions.dpInterestCharges.clear("dpiDetails");
                    this.actions.dpInterestDetails.getDpInterestDetails(data, "dpiDetails");
                }
                this.actions.dpInterestDetails.stopLoader("dpiDetails");
            },
            onError: (error) => {
                this.actions.dpInterestDetails.stopLoader("dpiDetails");
                this.actions.dpInterestDetails.setError({ isOpen: true, error }, "dpiDetails");
            },
        }, req);
    }
}
export default DpInterestReport;
